import { ScreeningLight } from './screeningInvite';

export class ArgyleViewBag {
    // Identity Data
    identityData: IdentityViewBag;

    // Paystubs
    paystubData: ArgylePaystubViewBag[];
    summary: RIQIncomeSummary;
}

export class ArgyleViewBagResponse { 
    demBags: ArgyleViewBag[];
    streams : ArgyleIncomeStream[];
}

//Response shape for GET /api/reportdata/income/fetch/{screeningId}
export class ArgyleIncomeFetchResponse {
    streams: ArgyleIncomeStream[];
    argyleInvite?: unknown;
}

export class ArgyleIncomeStream{
    status :string;
    firstName: string;
    lastName :string;
    streamType: IncomeStreamType;
    subType: IncomeSourceSubType;
    historicalData: any[];
    summary: RIQIncomeSummary ;
    screening : ScreeningLight;
    streamIdentifier: string;

    public get streamTypeString() : string {
        if(this.streamType == 0 ) return 'Payroll Sync';
        else if(this.streamType == 1) return "Bank Account Sync";
        else if(this.streamType == 2) return "Doc Upload";
        else if(this.streamType == 3) return "EFX Work Number";
        else return "Unknown";
    }

    public get streamSubTypeString() : string {
        if(this.subType == 0) return "Employment Sync";
        else if(this.subType == 1) return "Checking Sync";
        else if(this.subType == 2) return "Savings Sync";
        else if(this.subType == 3) return "Paystub Upload";
        else if(this.subType == 4) return "W2 Upload";
        else if(this.subType == 5) return "Bank Statement Upload";
        else if(this.subType == 6) return "1099 Upload";
        else return "NA";
    }
}

export enum IncomeStreamType
{
    PayrollSync = 0,
    BankSync = 1,
    DocUpload = 2,
    WorkNumber = 3
}

export enum IncomeSourceSubType
{
    Employment = 0,
    Checkings = 1,
    Savings = 2,
    Paystubs = 3,
    W2 = 4,
    BankStatements = 5,
    Form1099 = 6
}

export class RIQIncomeSummary {
    monthlyGrossAverage: number;
    monthlyNetAverage: number;
}

export class ArgylePaystubViewBag {
    grossPay: number;
    grossPay_YTD: number;
    netPay: number;
    netPay_YTD: number;
    currency: string;
    employerName: string;
    employerAddress: Address;
    periodStartDate: Date | string;
    paystubDate: Date | string;
    periodEndDate: Date | string;
    paystubOrigin: ArgylePaystubSource;
    paystubOriginstr: string;
}

export enum ArgylePaystubSource { 
    PayrollSystemSync = 0,
    UserFormUpload = 1
}


export interface IdentityViewBag {
    id: string;
    account: string;
    address: Address;
    first_name: string;
    last_name: string;
    full_name: string;
    birth_date: string;
    email: string;
    phone_number: string;
    picture_url: string;
    employment_status: string;
    employment_type: string;
    job_title: string;
    marital_status: string;
    gender: string;
    hire_date: string;
    original_hire_date: string;
    termination_date: any;
    termination_reason: any;
    employer: string;
    base_pay: BasePay;
    pay_cycle: string;
    created_at: Date | string;
    updated_at: Date | string;
}

export enum ArgyleUserFormType { 
    Paystub = 0,
    W2 = 1,
    BankStatement = 3
}
export class Address {
    City: string;
    Line1: string;
    Line2: any;
    State: string;
    Country: string;
    PostalCode: string;
}

export class BasePay {
    amount: string;
    period: string;
    currency: string;
}


export class AdditionalIncomeSource {
    id: number;
    screeningId: number;
    amount: number;
    incomeType: AdditionalIncomeSourceType;
    incomeSourceDescription: string;
    userId: number;
    createdDate: Date | string;
    userName: string;
}

export enum AdditionalIncomeSourceType { 
    taxDocuments = 0,
    governmentIncome = 1,
    employmentVerification = 2,
    employmentOffer = 3,
    currentEmployment = 4
}

export class ScreeningIncomeOverview {
    id: number;
    screeningId: number;
    discoveredIncomeAmount: number;
    suppliedIncomeRecDec: string;
    suppliedIncomePercentDiff: number;
    suppliedIncomeRIQScore: number;
    applicantSuppliedIncome: number;
    suppliedIncomeRatio: number;
    discoveredIncomeRatio : number;
}

// ── Draft Income Sources (Income Wizard) ────────────────────────────

export interface DraftIncomeSource {
    id: number;
    wizardStateId: number | null;
    screeningId: number;
    streamType: number;
    subType: number;
    streamIdentifier: string;
    employerName: string;
    incomeAmount: number;
    payFrequency: number;
    suggestedAmount: number;
    status: string;
    createdByUserId: number | null;
    createdDate: string;
    reviewedByUserId: number | null;
    notes: string;
    isExcluded: boolean;
    exclusionReasonId: number | null;
    exclusionReasonText: string | null;
    detailJson: string | null;
}

export function draftStreamTypeString(streamType: number): string {
    switch (streamType) {
        case IncomeStreamType.PayrollSync: return 'Payroll Sync';
        case IncomeStreamType.BankSync: return 'Bank Account Sync';
        case IncomeStreamType.DocUpload: return 'Doc Upload';
        case IncomeStreamType.WorkNumber: return 'EFX Work Number';
        default: return 'Unknown';
    }
}

export function draftSubTypeString(subType: number): string {
    switch (subType) {
        case IncomeSourceSubType.Employment: return 'Employment Sync';
        case IncomeSourceSubType.Checkings: return 'Checking Sync';
        case IncomeSourceSubType.Savings: return 'Savings Sync';
        case IncomeSourceSubType.Paystubs: return 'Paystub Upload';
        case IncomeSourceSubType.W2: return 'W2 Upload';
        case IncomeSourceSubType.BankStatements: return 'Bank Statement Upload';
        case IncomeSourceSubType.Form1099: return '1099 Upload';
        default: return 'NA';
    }
}

export enum IncomeWizardPayFrequency {
    Weekly = 0,
    BiWeekly = 1,
    SemiMonthly = 2,
    Monthly = 3,
    Annual = 4
}

// ── Draft Detail JSON Types ─────────────────────────────────────────

export interface PayrollDetail {
    employerName: string;
    employmentType: string;
    employmentStatus: string;
    firstName: string;
    lastName: string;
    jobTitle: string;
    basePay: number | null;
    basePayUnit: string;
    payCycle: string;
    hireDate: string;
    terminationDate: string | null;
    terminationReason: string | null;
    recentPaystubs: PayrollPaystubEntry[];
}

export interface PayrollPaystubEntry {
    payDate: string;
    grossPay: number;
    netPay: number;
}

export interface BanksyncDetail {
    accountName: string;
    accountType: string;
    institutionName: string;
    subStreams: BanksyncSubStreamDetail[];
}

export interface BanksyncSubStreamDetail {
    id: string;
    name: string;
    confidence: number;
    cadenceDays: number | null;
    avgMonthlyNet: number;
    status: string;
    recentDeposits: BanksyncDepositEntry[];
}

export interface BanksyncDepositEntry {
    date: string;
    amount: number;
}

export interface DocUploadDetail {
    docType: string;
    taxYear: string;
    employerName: string;
    employerIdNo: string;
    recipientName: string;
    annualAmount: number | null;
    perPeriodGross: number | null;
    payFrequency: string;
    documentId: string;
    fileName: string;
    authenticityScore: number;
    ocrClassification: string;
    ocrStatus: string;
    authenticityStatus: string;
    fraudSignals: DocFraudSignal[];
}

export interface DocFraudSignal {
    code: string;
    confidence: string;
    description: string;
}

export interface WorkNumberDetail {
    employerName: string;
    employmentStatus: string;
    hireDate: string;
    jobTitle: string;
    projectedAnnualIncome: number | null;
    rateOfPay: number | null;
    payFrequency: string;
    payPeriodFrequency: string;
    avgHoursWorked: number | null;
    annualCompHistory: WorkNumberAnnualComp[];
}

export interface WorkNumberAnnualComp {
    year: string;
    total: number;
}